
import { Component, Prop, Mixins } from 'vue-property-decorator';
import { AthleteAutocompleteInfo } from '@best-athletes/ba-types';
import { StringsMixin } from '@/mixins';
@Component
export default class AthletePreview extends Mixins(StringsMixin) {
	@Prop({ required: true }) value: AthleteAutocompleteInfo;
}
